import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
/* @ts-self-types="./index.d.ts" */
import { urlAlphabet as scopedUrlAlphabet } from './url-alphabet/index.js';
export { urlAlphabet } from './url-alphabet/index.js';
export let random = bytes => crypto.getRandomValues(new Uint8Array(bytes));
export let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << Math.log2(alphabet.length - 1)) - 1;
  let step = -~(1.6 * mask * defaultSize / alphabet.length);
  return function () {
    let size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSize;
    let id = '';
    while (true) {
      let bytes = getRandom(step);
      let j = step | 0;
      while (j--) {
        id += alphabet[bytes[j] & mask] || '';
        if (id.length >= size) return id;
      }
    }
  };
};
export let customAlphabet = function (alphabet) {
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 21;
  return customRandom(alphabet, size | 0, random);
};
export let nanoid = function () {
  let size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
  let id = '';
  let bytes = crypto.getRandomValues(new Uint8Array(size |= 0));
  while (size--) {
    id += scopedUrlAlphabet[bytes[size] & 63];
  }
  return id;
};